import React, {memo} from 'react';
import {Grid} from '@mui/material';
import {GridCellParams, GridColDef, DataGridPro} from '@mui/x-data-grid-pro';
import {useTranslation} from 'react-i18next';
import {formatDateTime} from 'common/dateUtils';
import Panel from 'components/Panel';
import Dialog from 'components/Dialog';
import {PrimaryButton} from 'components/buttons/PrimaryButton';
import Button from 'components/Button';
import {ILogFileDescriptor, LogFileDescriptorsWithId} from 'types/diplomat/logs/LogFileDescriptor';

type Props = {
   onClose: (names?: string[]) => void;
   files: ILogFileDescriptor[];
};
const LogViewRequestDialog = memo(({onClose, files}: Props) => {
   const {t} = useTranslation();

   const [selected, setSelected] = React.useState<string[]>([]);

   const holidayColumns = React.useMemo(
      () =>
         [
            {field: 'filename', headerName: t('Log File Name'), flex: 400},
            {
               field: 'lastModified',
               headerName: t('Date'),
               flex: 300,
               valueFormatter: (params: GridCellParams) => {
                  return formatDateTime(params.value as Date);
               },
            },
         ] as GridColDef[],
      [t]
   );

   const data = React.useMemo(() => LogFileDescriptorsWithId.cast(files), [files]);

   return (
      <Dialog maxWidth="md" header={t('Choose Log Files To View')} close={() => onClose()}>
         <Panel>
            <div style={{height: 500, width: '100%'}}>
               <DataGridPro
                  rows={data}
                  columns={holidayColumns}
                  pageSize={7}
                  checkboxSelection
                  onSelectionModelChange={(selectionModel) => {
                     // console.debug(param);
                     setSelected(selectionModel as string[]);
                  }}
               />
            </div>
         </Panel>
         <Grid container spacing={3} justifyContent="center">
            <Grid item>
               <PrimaryButton type="submit" onClick={() => onClose(selected)}>
                  {t('Ok')}
               </PrimaryButton>
            </Grid>
            <Grid item>
               <Button type="button" onClick={() => onClose()}>
                  {t('Cancel')}
               </Button>
            </Grid>
         </Grid>
      </Dialog>
   );
});

export default LogViewRequestDialog;
